import React, { Component } from "react";
import CircularProgress from "@material-ui/core/CircularProgress";

class PrivacyPolicy extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoaded: true,
    };
  }

  render() {
    const { isLoaded } = this.state;

    return (
      <div style={containerStyle}>
        <h2 style={headerStyle}>Privacy Policy</h2>
        {!isLoaded ? (
          <div style={{ textAlign: "center" }}>
            <CircularProgress color="secondary" />
          </div>
        ) : (
          <div style={textStyle}>
            <p>
              This website is owned, hosted, and operated by "JC Creations". All content featured or displayed, including but not limited to text, graphics, layout, and trademarks, is the property of JC Creations or its partners.
            </p>
            <p>By using the website, you agree to:</p>
            <ul style={listStyle}>
              <li>Provide accurate, current, and complete information.</li>
              <li>Keep your data up to date.</li>
              <li>Safeguard your login credentials.</li>
              <li>Report unauthorized access immediately.</li>
              <li>Take full responsibility for your account.</li>
              <li>Accept risks associated with any data breaches.</li>
            </ul>
          </div>
        )}
      </div>
    );
  }
}

export default PrivacyPolicy;

const containerStyle = {
  background: "linear-gradient(to bottom right, #fff8f2, #fde9e0)",
  padding: "40px 20px",
  fontFamily: "Arial, sans-serif",
  minHeight: "100vh",
  color: "#444",
};

const headerStyle = {
  fontSize: "28px",
  fontWeight: "bold",
  color: "#b0452b",
  textAlign: "center",
  marginBottom: "20px",
};

const textStyle  = {
  fontSize: "16px",
  lineHeight: "1.8",
  maxWidth: "800px",
  margin: "0 auto",
};

const listStyle = {
  paddingLeft: "20px",
  listStyleType: "disc",
};
